import React, { createContext, FunctionComponent, useContext, useMemo } from 'react'
import { Outlet, useLocation } from 'react-router'

import { Page } from '../../../../infrastructure/routing'
import { CheckoutConfig } from './types'

const quotePage: Page = { id: 'quote', url: '../../..' }
const paymentPage: Page = { id: 'payment', url: '../../../payment' }

interface CheckoutProviderProps {
  next: Page
  previous: Page
}

const CheckoutContext = createContext<undefined | CheckoutProviderProps>(undefined)

export const CheckoutProvider: FunctionComponent<{
  checkoutConfigs: CheckoutConfig[]
}> = ({ checkoutConfigs }) => {
  const { pathname } = useLocation()

  const currentPath = pathname.split('/').pop()
  const index = checkoutConfigs.findIndex((r) => r.path === currentPath)

  const value: CheckoutProviderProps = useMemo(() => {
    const previous = checkoutConfigs[index - 1]
    const next = checkoutConfigs[index + 1]

    return {
      previous: previous ? { id: previous.id, url: `../${previous.path}` } : quotePage,
      next: next ? { id: next.id, url: `../${next.path}` } : paymentPage,
    }
  }, [index])

  return (
    <CheckoutContext.Provider value={value}>
      <Outlet />
    </CheckoutContext.Provider>
  )
}

export const useCheckout = () => {
  const context = useContext(CheckoutContext)

  if (!context) {
    throw new Error('Cannot use CheckoutContext when undefined.')
  }

  return context
}
